import { Sidebar, NAV, useRoute, type Role, type NavSection } from "@mypos/ui";
import { useAuthStore } from "../lib/authStore";

// Manager mirrors Till's full sidebar so both apps surface the same 27 pages.
// The "Till" section is renamed to "POS" so the heading reads naturally for an
// owner browsing on the PWA; every item underneath remains the same.
const MANAGER_NAV: NavSection[] = NAV.map((section) =>
  section.title === "Till"
    ? { ...section, title: "POS", titleKey: "nav.posSection" }
    : section,
);

export function ManagerSidebar() {
  const role = useAuthStore((s) => (s.user?.role as Role | null) ?? "manager");
  const permissions = useAuthStore((s) => s.user?.permissions);
  const page = useRoute((s) => s.page);
  const go = useRoute((s) => s.go);

  return (
    <Sidebar
      sections={MANAGER_NAV}
      role={role}
      permissions={permissions}
      activeId={page}
      onNavigate={(id) => go(id, role)}
    />
  );
}
